import styled from 'styled-components';

import { Color, FontWeight, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';

export const Container: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const RadioCheckMark: StyledComponent<'span'> = styled.span`
  width: 16px;
  height: 16px;
  border: 1px solid ${Color.Gray400};
  border-radius: 50%;
  position: relative;
  flex-shrink: 0;

  &:after {
    content: '';
    position: absolute;
    display: none;
  }
`;

export const RadioInput: StyledComponent<'input'> = styled.input`
  opacity: 0;
  cursor: pointer;
  position: absolute;
  z-index: ${ZIndex.Min};
  border: 1px solid ${Color.Stroke};

  &[type="radio"] {
    width: 16px;
    height: 16px;
  }

  &:checked + ${RadioCheckMark} {
    opacity: 1;
    background-color: ${Color.White};
    border: 1px solid ${Color.Error500};
  }

  &:checked + ${RadioCheckMark}:after {
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: ${Color.Error500};
  }
`;

export const Label: StyledComponent<'label'> = styled.label`
  font-size: 16px;
  line-height: 22px;
  color: ${Color.Black};
  margin-right: 18px;
  cursor: pointer;
`;

export const RadioAndLabelContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;

  ${RadioCheckMark} + ${Label} {
    margin-left: 18px;
  }
`;

export const AdditionalAttribute: StyledComponent<'div'> = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: ${Color.Black};
  font-weight: ${FontWeight.Medium};
`;
